module.exports = __webpack_public_path__ + "img/car_shina2_39.c92c2faf.jpg";